export class Export {
  public static projectColumns = [
    { code: 0, key: 'Id', selected: true },
    { code: 1, key: 'Name', selected: true },
    { code: 2, key: 'NameEn', selected: true },
    { code: 3, key: 'Acronym', selected: true },
    { code: 4, key: 'InternationalProject', selected: true },
    { code: 5, key: 'Provider', selected: true },
    { code: 6, key: 'ProviderSubject', selected: true },
    { code: 7, key: 'GrantProgram', selected: true },
    { code: 8, key: 'PriorityAxis', selected: true },
    { code: 9, key: 'ProjectCall', selected: true },
    { code: 10, key: 'Role', selected: true },
    { code: 11, key: 'Coordinator', selected: true },
    { code: 12, key: 'Partners', selected: true },
    { code: 13, key: 'ResponsibleFaculty', selected: true },
    { code: 14, key: 'Solver', selected: true },
    { code: 15, key: 'Description', selected: true },
    { code: 16, key: 'DescriptionEn', selected: true },
    { code: 17, key: 'Note', selected: true },
    { code: 18, key: 'State', selected: true },
    { code: 19, key: 'StartedOn', selected: true },
    { code: 20, key: 'EndedOn', selected: true },
    { code: 21, key: 'IsDeMinimsSupport', selected: true },
    { code: 22, key: 'IsSustainable', selected: true },
    { code: 23, key: 'SustainabilityDuration', selected: true },
    { code: 24, key: 'InternationalProject', selected: true },
    { code: 25, key: 'IsNonResearchProject', selected: true },
    { code: 26, key: 'Category', selected: true },
    { code: 27, key: 'MainFieldGroup', selected: true },
    { code: 28, key: 'MainField', selected: true },
    { code: 29, key: 'SecondaryField', selected: true },
    { code: 30, key: 'OtherField', selected: true },
    { code: 31, key: 'StudyProgram', selected: true },
    { code: 32, key: 'SocioEconomicBenefitPrimaryArea', selected: true },
    { code: 33, key: 'PredominantFundingSource', selected: true },
    { code: 34, key: 'ProjectType', selected: true },
    { code: 35, key: 'GrantContractNumber', selected: true },
    { code: 36, key: 'GrantContractSignDate', selected: true },
    { code: 37, key: 'ProjectNumber', selected: true },
    { code: 38, key: 'ProjectLink', selected: true },
    { code: 39, key: 'DatabaseLink', selected: true },
    { code: 40, key: 'SustainabilityNote', selected: true },
    { code: 41, key: 'OtherSolvers', selected: true },
    { code: 42, key: 'CurrencyCode', selected: true },
    { code: 43, key: 'Budget', selected: true },
    { code: 44, key: 'GrantAmount', selected: true },
    { code: 45, key: 'GrantAmountPercentage', selected: true },
    { code: 46, key: 'CoFinancingPublicSourcesAmount', selected: true },
    { code: 47, key: 'CoFinancingPublicSourcesPercentage', selected: true },
    { code: 48, key: 'CoFinancingNonPublicSourcesAmount', selected: true },
    { code: 49, key: 'CoFinancingNonPublicSourcesPercentage', selected: true },
    { code: 50, key: 'TotalCoFinancing', selected: true },
    { code: 51, key: 'ShareOfInvestmentCosts', selected: true },
    { code: 52, key: 'ShareOfNonInvestmentCosts', selected: true }
  ];
  public static projectSimpleColumns = [
    { code: 0, key: 'Id', selected: true },
    { code: 1, key: 'Name', selected: true },
    { code: 2, key: 'Provider', selected: true },
    { code: 3, key: 'Coordinator', selected: true },
    { code: 4, key: 'Partners', selected: true },
    { code: 5, key: 'Solver', selected: true },
    { code: 6, key: 'Description', selected: true },
    { code: 7, key: 'Note', selected: true },
    { code: 8, key: 'StartedOn', selected: true },
    { code: 9, key: 'EndedOn', selected: true },
    { code: 10, key: 'ProjectType', selected: true },
    { code: 11, key: 'GrantContractNumber', selected: true },
    { code: 12, key: 'GrantContractSignDate', selected: true },
    { code: 13, key: 'Budget', selected: true },
    { code: 14, key: 'TotalBudgetUniversity', selected: true },
    { code: 15, key: 'ShareOfInvestmentCosts', selected: true }
  ];
}
